<template>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-8">
        <c-card title="Crear versión">
          <marco-legal-general-version-form />
        </c-card>
      </div>
    </div>
  </div>
</template>
<script>
import MarcoLegalGeneralVersionForm from "@/components/MarcoLegalGeneral/MarcoLegalGeneralVersionForm.vue";
import CCard from "@/components/CCard.vue";
export default {
  components: {
    MarcoLegalGeneralVersionForm,
    CCard,
  },
};
</script>
